import { useEffect, useState } from 'react'
import styles from './style.scss'
import { ICardBinInfo } from '../PaymentModal'
import { NativeProps, withNativeProps } from 'antd-mobile/es/utils/native-props'

const alias = {
  label: 'title',
  value: 'id',
  remarks: 'remarks',
  logo: 'logo',
}

const Groups = (props) => {
  const { options, onChange, value, style } = props
  const [_val, _setVal] = useState(value)
  useEffect(() => {
    _setVal(value)
  }, [value])
  const onValueChange = (value, item) => {
    console.log('click', value, item)
    onChange(value, item)
  }

  return withNativeProps(
    props,
    <div className={styles['card-bin-radio']}>
      {options.map((option) => {
        return (
          <CardBinRadioItem
            key={option[alias['value']]}
            onClick={() => onValueChange(option[alias['value']], option)}
            checked={option[alias['value']] === _val}
            {...option}
          />
        )
      })}
    </div>,
  )
}
const CardBinRadioItem = (props: any) => {
  const { onClick, checked } = props

  return (
    <li className={styles['card-bin-radio-item']} onClick={onClick}>
      <img
        className={styles['card-bin-radio-item_logo']}
        src={props[alias['logo']]}
        alt={props[alias['label']]}
      />
      <span className={styles['card-bin-radio-item_name']}>
        {props[alias['label']]}
      </span>
      <span className={styles['card-bin-radio-item_remarks']}>
        {props[alias['remarks']]}
      </span>
      <i
        className={`${styles['card-bin-radio-item_radio']} ${
          checked ? styles['card-bin-radio-item_radio--checked'] : ''
        } `}
      />
    </li>
  )
}

export default function CardBinRadio(
  props: {
    options: any[]
    onChange: (value: string, item: ICardBinInfo) => void
    value?: string
    style?: React.CSSProperties
  } & NativeProps,
) {
  return <Groups {...props} />
}
